{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Sláðu inn netfangið sem þú notar til að skrá þig inn í þjónustuverið til að fá leiðbeiningar um endurstillingu lykilorðs.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Tölvupóstfang",
      "PLACEHOLDER": "Vinsamlegast sláðu inn netfangið þitt.",
      "ERROR": "Vinsamlegast skrifaðu gilt netfang."
    },
    "API": {
      "SUCCESS_MESSAGE": "Tengill til að endurstilla lykilorð hefur verið sendur á netfangið þitt.",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
    },
    "SUBMIT": "Senda"
  }
}
